package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/dog-man". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/dog-man")
@Composable
fun DogManReviewPage() {
    PublicReviewPage(
        slug = "dog-man",
        blurb = "Is Dog Man OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
